import React from "react";
import { db } from "@/db";
import { GalleryType, PostType } from "@/core/types/contentTypes";
import { IndexableType } from "dexie";
import { useOfflineImageContent } from "@/hooks/indexeddb/useOfflineImageContent";
import GalleryApi from "@/connectors/fcWordpress/apiCallers/GalleryApi";

type OfflineGalleryContent = {
  downloadGallery: (postId: PostType) => Promise<IndexableType>;
  getDownloadedGallery: (id: number) => Promise<GalleryType | undefined>;
  deleteGallery: (id: number, withPost?: boolean) => void;
};

export const useOfflineGalleryContent = (): OfflineGalleryContent => {
  const { saveImage } = useOfflineImageContent();

  const downloadGallery = async (post: PostType) => {
    const api = new GalleryApi({
      id: post.id.toString(),
      language: process.env.NEXT_PUBLIC_DEFAULT_ROUTING_LANGUAGE_CODE!,
    });
    await api.fetchGallery();
    const images = (api.result as GalleryType)?.images;

    images?.map(async (image) => {
      await saveImage(image.sizes[0].url, post.id);
    });

    await precacheUrl(post);

    return db.galleries.put({ id: post.id, gallery: { images, relatedGalleries: [] } }, post.id);
  };

  const precacheUrl = async (post: PostType) => {
    if ("caches" in window) {
      caches.open("others").then((cache) => {
        const url = `/galerie/offline/${post.id}/${post.slug}`;
        cache.add(url);
      });
    }
  };

  const getDownloadedGallery = async (id: number) => {
    const gallery = await db.galleries.get(id);
    return gallery?.gallery;
  };

  const deleteGallery = async (id: number) => {
    await db.imageSources.where("postId").equals(id).delete();
    return db.galleries.delete(id);
  };

  return {
    downloadGallery,
    getDownloadedGallery,
    deleteGallery,
  };
};
